import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { WarningLoginComponent } from 'src/app/components/modals/warning-login/warning-login.component';
import { CommonsService } from 'src/app/services/commons.service';
import { EntitiesService } from 'src/app/services/entities.service';
import { CONSTANTS } from 'src/app/shared/constants';
import { ChangeDetectorRef } from '@angular/core';
declare var document;

@Component({
  standalone: false,
  selector: 'app-tink-response',
  templateUrl: './tink-response.component.html',
  styleUrls: ['./tink-response.component.scss']
})
export class TinkResponseComponent implements OnInit {

  country: string;
  language: string;
  showError = false;
  showIcon: any = 1;
  headerFooter: boolean;
  warningModalConfig = new MatDialogConfig();
  contratacion: boolean;
  isRapidScore = false;
  showLoading = false;
  hideTryButton = false;
  channel;
  constructor(
    private translate: TranslateService,
    private readonly modal: MatDialog,
    private readonly activatedRoute: ActivatedRoute,
    private readonly cdr: ChangeDetectorRef,
    private router: Router,
    private entitiesService: EntitiesService,
    private c: CommonsService
  ) { }

  ngOnInit() {
    const params = this.activatedRoute.snapshot.queryParams
    if (params.error) {
      console.log(params)
    }
    const splitToken = window.atob(params.state).split('&channel=');
    this.isRapidScore = CONSTANTS.getChannels(splitToken[1]);
    this.channel = splitToken[1];
    sessionStorage.setItem('getParams',JSON.stringify([String(this.channel),"","0"]))
    this.entitiesService.getTinkToken(splitToken[0]).subscribe(data => {
      const paramsData = {
        'account_verification_report_id': params['account_verification_report_id'],
        'transaction_report_id':  params['transaction_report_id'],
        'request': data.Token
      };
      this.language=data.Language
      this.country=data.Country
      sessionStorage.setItem('country', this.country);
      sessionStorage.setItem('language', this.language);
      this.showLoading = true;
      this.translate.use(this.language);
      document.documentElement.lang = this.language.substring(0, 2);
      this.cdr.detectChanges();
      if (params.error) {
        this.hideTryButton = true;
        this.showError = true;
        this.entitiesService.postTinkError({
          error: params.error,
          error_reason: params.error_reason,
          message: params.message,
          tracking_id: params.tracking_id
        }, data.Token).subscribe()
      } else {
        if (this.isRapidScore) {
          this.entitiesService.getTinkRapidScore(paramsData).subscribe((data) => {
            this.postRapidScore(data);
          }, () => {
            this.showError = true;
          });
        } else {
          this.entitiesService.getTinkResponse(paramsData).subscribe((data) => {
            this.postAggretation(this.formatKPIs(data));
          }, () => {
            this.showError = true;
          });
        }
      }

    });



  }


   /**
   * compruena la respuesta del servicio y levanta modal
   * @param code: number
   * @param sca: object
   */
  private postAggretation(d) {
    if (d.resultEA && d.resultEA.message) {
      this.warningModalConfig.data = { text: d.resultEA.message };
      this.modal.open(WarningLoginComponent, this.warningModalConfig);
      return;
    }
    if (d.Code !== 200) {
      this.showError = true;
    } else if (d.Code === 200) {
      sessionStorage.removeItem('_k');
      sessionStorage.setItem('_k', this.c.encrypt(d));
      this.c.setKpi(d);
      sessionStorage.removeItem('gs');
      sessionStorage.removeItem('bankCode');
      sessionStorage.removeItem('banksEntities');
      sessionStorage.removeItem('refreshEntityCode');
      sessionStorage.removeItem('Channel');
      this.router.navigateByUrl('global-position');

    }
  }

  private postRapidScore(d) {
    if (d.resultEA && d.resultEA.message) {
      this.warningModalConfig.data = { text: d.resultEA.message };
      this.modal.open(WarningLoginComponent, this.warningModalConfig);
      return;
    }
    if (d.Code === 401) {

    } else if (d.Code === 403) {
      this.showError = true;
      return;
    }
    this.router.navigateByUrl('engagement');
    sessionStorage.setItem('t', d.Token);
    sessionStorage.setItem('_k', this.c.encrypt(d));
    this.c.setKpi(d);
  }

  private formatKPIs(d) {
    d.kpis = [];
    if (d.score.CategoryScore) {
      d.score.CategoryScore.forEach(a => {
        a.CategoryKpiList.forEach(b => d.kpis.push(b));
      });
    }
    return d;
  }

}
